<template>
    <div>
        <div class="white-box mt-3">
            <div class="data-group">
                <M3FormTitle title="Asigurarea serviciilor GDPR" :checked="completed"></M3FormTitle>
                <p class="title mt-4">Vă rugăm să bifați mai jos modalitatea prin care se realizează protecția datelor cu caracter personal. Persoana desemnată ca responsabil cu protecția datelor cu caracter personal trebuie să dețină cunoștințele de specialitate în dreptul și practicile din domeniul protecției datelor și să fie certificată în domeniul GDPR. În situaţia în care se optează pentru externalizarea serviciului, se va prezenta acest lucru la capitolul referitor la prezentarea Resurselor umane implicate, arătând care este rolul responsabilului GDPR în proiect.</p>
                <b-form ref="formular">
                    <b-form-group label="Modalitatea de a asigura serviciile GDPR" class="custom-radio-group mt-4" :class="errorInput ? 'error-input' : ''">
                        <b-form-radio v-model="gdpr" name="gdpr" :disabled="completed" value="certified_person" :class="gdpr === 'external_services' ? 'strike' : ''" @change="errorInput = false">Se desemnează din cadrul {{ companyName }} o persoană certificată responsabilă cu protecția datelor cu caracter personal, având atribuții conform fișei postului.</b-form-radio>
                        <b-form-radio v-model="gdpr" name="gdpr" :disabled="completed" value="external_services" :class="gdpr === 'certified_person' ? 'strike' : ''" @change="errorInput = false">Se vor externaliza serviciile privind responsabilul cu protecția datelor cu caracter personal.</b-form-radio>
                    </b-form-group>
                </b-form>

                <hr class="mt-5">
                <b-form-checkbox
                    v-model="completed"
                    switch
                    size="lg"
                    class="switch-box"
                    @change="completeForm()"
                >Informațiile sunt complete și corecte</b-form-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import { BForm, BFormCheckboxGroup, BFormGroup, BFormCheckbox, BFormRadio} from "bootstrap-vue";
    export default {
        components: {
            BForm,
            BFormCheckboxGroup,
            BFormGroup,
            BFormCheckbox,
            BFormRadio,
            M3FormTitle,
        },
        props: {
            gdpr_info: null,
        },
        data() {
            return {
                completed: null,
                gdpr: null,
                errorInput: false,
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            companyName() {
                return this.$store.getters['m3Sketch/m3Company'] ? this.$store.getters['m3Sketch/m3Company'].name : ''
            }
        },
        watch:{
            gdpr_info: {
                handler: function() {
                    if(this.gdpr_info){
                        this.gdpr = this.gdpr_info
                        this.completed = true
                    }
                },
                deep: false
            },
            checks: {
                handler: function() {
                    this.completed = this.checks.proiectulMeuGdpr;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.gdpr_info){
                this.gdpr = this.gdpr_info
                this.completed = true
            }
        },
        methods: {
            completeForm() {
                if(!this.gdpr) {
                    this.completed = false
                    this.errorInput = true
                    this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                } else{
                    this.gdprSend = {
                        gdpr: this.gdpr
                    }
                    this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.gdprSend)
                        .then((firstResponse) => {
                            this.$toast.success(firstResponse.data)
                        }).catch((xhr) => {
                            if (xhr.status === 422) {
                                this.errors.record(xhr.responseJSON.errors);
                            }
                            this.$toast.error(xhr.response.data.message);
                        });
                }
                if(this.checks.proiectulMeuGdpr !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuGdpr', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.strike >>> label{
    text-decoration: line-through;
}
.custom-radio-group >>> label {
    font-size: 14px;
}
.error-input >>> label {
    color: var(--dangerColor);
}
.data-group{
    margin: auto;
    width: 85%;
}
.flex{
    display: flex;
    align-items: flex-end;
}
.flex img{
    margin-right: 10px;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px !important;
}
.title{
    font-size: 14px;
    color: #5b6276;
}
.checkboxes >>> label{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
}
.switch-box{
    text-align: right;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.checkboxes >>> .custom-checkbox{
    margin: 10px 0;
}
.delete-icon{
    color: var(--dangerColor);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    right: -20px;
    cursor: pointer;
}
.form-group >>> legend{
    text-align: left;
    font-size: 14px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input, input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    max-height: 30px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: flex-start;
}
.adauga-locatie{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.custom-select{
    color: #767a95;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 2px;
    max-height: 33px;
    margin: 0 !important;
    font-weight: 600;
    background: #e9ecef url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.form-group >>> .form-row{
    align-items: center !important;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
</style>
